export default __webpack_public_path__ + "9258a2b1b8b4c900990c08b3d7cb20e6.png";